import React from 'react'

function Td({ children, ...rest }) {
    return (
        <td {...rest} className='px-3 py-2.5 capitalize'>{children}</td>
    )
}

export default Td